var utils = require('../../utils')
import AppHeader from '../AppHeader'

export default {
  name: 'deadline-notice-list',
  created () {
    this.search(false)
  },
  data () {
    return {
      searchCallbackFlag: false
    }
  },
  computed: {
    notices () {
      return this.$store.getters.notices
    }
  },
  components: {
    AppHeader
  },
  methods: {
    search: function () {
      var data = {'user_id': window.localStorage.getItem('user_id')}
      var self = this
      var callback = function () {
        self.searchCallbackFlag = true
      }
      this.$store.dispatch('GET_NOTICE', {data: data, callback: callback} )
    },
    goUserPdf: function(userId) {
      window.sessionStorage.setItem('BackPage', '/deadline_notices')
      this.$router.push({ path: '/users/' + userId + '/pdf'})
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/scripts/deadline-notice-list.js